import { useQueryGrid } from '@gogame/query';

import { loadTags } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/tags';

import { tagsGrid } from './queryKeyFactory';

export const useLoadTags = () => {
  return useQueryGrid(tagsGrid(), (_, { signal }) => loadTags({}, { signal }));
};
